export const pxToVh = (px: number) => `${(px / 700) * 100}vh`;
